// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import router from './router'
import  'element-ui/lib/theme-chalk/index.css'
import api from './common/constants';
import http from './common/http';
import 'lib-flexible'
import VueLazyload from 'vue-lazyload'
import ba from 'vue-ba'

import bffApi from './api/index'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
// 功能组件
import funtionMap from '@/components/functionMap/index.vue';
Vue.component('funtion-map', funtionMap)

// 筛选按钮
import selectOption from '@/components/select-option.vue'
Vue.component('select-option', selectOption)

// 全局侧边栏
import SidebarTree from '@/components/sidebarTree/sidebar_tree.vue';
Vue.component('sidebar-tree', SidebarTree)

// import 'default-passive-events'
// 弹窗
import Message from '../src/components/message/'
Vue.prototype.$my_message = Message;
Vue.use(VueLazyload, {
        loading: require('../static/images/update_img.png') //这里引入的是加载时的loading图
    })
    // 全局注册SimilarArticles组件
import CwSimilarArticles from '@/components/cw-similar-articles.vue'
Vue.component('cw-similar-articles', CwSimilarArticles)

// 全局注册公众号搜索详情
import OfficialAccountPopup from '@/components/searchPopup/official-account-popup.vue'
Vue.component('official-account-popup', OfficialAccountPopup)
    // 监控下次发文组件
import monitorPopup from "@/components/searchPopup/monitor-popup.vue";
Vue.component('monitor-popup', monitorPopup)
    // 数据回采
import stopingPopup from "@/components/searchPopup/stoping-popup.vue";
Vue.component('stoping-popup', stopingPopup)
    // 相似公众号
import similarArticlesPopup from "@/components/searchPopup/similar-articles-popup.vue";
Vue.component('similar-articles-popup', similarArticlesPopup)
    // 投前分析
import analysisPopup from '@/components/searchPopup/analysis-popup.vue';
Vue.component('analysis-popup', analysisPopup)
    // 创建分组
import createdGroup from '@/components/searchPopup/create-group.vue';
Vue.component('create-group', createdGroup)

// 注册cw-similar-分页表格组件
import CwSimilarTable from '@/components/cw-similar-Table.vue'
Vue.component('cw-similar-table', CwSimilarTable)
import CwSimilarTh from '@/components/cw-similar-th.vue'
Vue.component('cw-similar-th', CwSimilarTh)
import CwSimilarTd from '@/components/cw-similar-td.vue'
Vue.component('cw-similar-td', CwSimilarTd)

// 组管理器组件
import management from '@/components/groupManagement/Management.vue';
Vue.component('management', management)

// 分组管理系统
import groupManagement from '@/components/searchPopup/group-management.vue';
Vue.component('group-management', groupManagement)
    // 树
import treePopup from '@/components/searchPopup/tree-popup.vue';
Vue.component('tree-popup', treePopup)

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$http = http;
Vue.prototype.$api = api;
Vue.prototype.$bffApi = bffApi

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
});
router.beforeEach((to, from, next) => {
    if (window._hmt) {
        if (to.path) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }
    next()
})


// WEBPACK FOOTER //
// ./src/main.js